import * as React from 'react'
import { sectionFactory } from '../SectionFactory';

export const ButtonGroup = sectionFactory('btn-group')
